import React from "react";
import { Drawer } from "antd";
import {
  Body,
  CloseButton,
  CloseMark,
  Footer,
  Header,
  MobileBottomSheetGlobalStyles,
  SheetHandle,
  SheetPanel,
  Title,
} from "./styles";


type MobileBottomSheetCloseEvent =
  | React.MouseEvent<Element>
  | React.KeyboardEvent<Element>;

type MobileBottomSheetProps = {
  open: boolean;
  onClose?: (event?: MobileBottomSheetCloseEvent) => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  height?: string | number;
  className?: string;
};

export default function MobileBottomSheet({
  open,
  onClose,
  title,
  children,
  footer,
  height = "calc(100dvh - 28px)",
  className = "",
}: MobileBottomSheetProps) {
  const handleClose = (event?: MobileBottomSheetCloseEvent) => {
    onClose?.(event);
  };

  const sheetClassName = `mobile-bottom-sheet ${className}`.trim();

  return (
    <>
      <MobileBottomSheetGlobalStyles />

      <Drawer
        placement="bottom"
        open={open}
        onClose={handleClose}
        footer={null}
        height={height}
        title=""
        closable={false}
        className={sheetClassName}
        rootClassName={sheetClassName}
        zIndex={1600}
      >
        <SheetPanel className={`mobile-bottom-sheet-panel ${className}`.trim()}>
          <SheetHandle className="mobile-bottom-sheet-handle" />

          {onClose && (
            <CloseButton
              type="button"
              aria-label="Close"
              className="mobile-bottom-sheet-close"
              onClick={handleClose}
            >
              <CloseMark aria-hidden="true" />
            </CloseButton>
          )}

          {title && (
            <Header className="mobile-bottom-sheet-header">
              <Title className="mobile-bottom-sheet-title">{title}</Title>
            </Header>
          )}

          <Body className="mobile-bottom-sheet-body">{children}</Body>

          {footer && <Footer className="mobile-bottom-sheet-footer">{footer}</Footer>}
        </SheetPanel>
      </Drawer>
    </>
  );
}
